module.exports = __webpack_public_path__ + "images/category_lp/electric_tool/assessment_achievements/1_e64467c244935e0618c38e6d1984bc44.jpg";